export const instructionFileName = {
    ru: 'Антифишинг — инструкция по установке и настройке плагина для Microsoft Outlook.pdf',
    en: 'Antiphish — plugin installation and configuration guide for Microsoft Outlook email client.pdf',
    it: 'Antiphish — Guida per l’installazione e la configurazione per il client di posta elettronica Microsoft.pdf'
};
